<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Cobranza</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <vx-card :title="'('+projects.length+') Proyectos en cobranza'">
          <div class="skinny row">
            <!-- <div class="col-md-2">
                <vs-select
                  placeholder="Seleccione"
                  multiple
                  label="Día de corte"
                  class="w-full"
                  v-model="cut_day"
                  >
                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in cut_day_options" />
                </vs-select>
            </div>
            <div class="col-md-4">
                <vs-select
                  placeholder="Seleccione"
                  multiple
                  label="Método de pago"
                  class="w-full"
                  v-model="payment_method"
                  >
                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in payment_method_options" />
                </vs-select>
            </div> -->
            <div class="col-md-4">
                <vs-select
                  placeholder="Seleccione"
                  multiple
                  label="Status"
                  class="w-full"
                  v-model="status"
                  >
                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in all_status" />
                </vs-select>
            </div>
            <div class="col-md-2">
              <div class="flex flex-wrap">
                <vs-button v-if="!loading" @click="getProjects" color="dark" class="mt-6 mr-1">Filtrar</vs-button>
                </div>
            </div>
          </div>
        <vs-table
          ref="projectsTable"
          stripe
          class="mt-5"
          :data="projects"
          noDataText="No hay datos disponibles"
        >
          <template slot="thead">
          <vs-th
            class="bold"
            v-for="(col, idx) in columns"
            v-bind:key="idx"
            :sort-key="col.sortable ? col.key : null"
          >{{col.title}}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
              <vs-td><a :href="$sanitizeUrl('/cobranza/' + tr.project_id)" class="bold pill-light" target="_blank">{{tr.project_id}}</a></vs-td>
              <vs-td>
                <strong>Días de atraso:</strong> <label :class="delayDaysPill(tr.delay)">{{tr.delay}}</label><br>
                <strong>Bucket:</strong> <label class="pill-blue">{{tr.bucket}}</label><br>
                <strong>Saldo vencido:</strong> ${{format_price(tr.due, 2)}}<br>
                <strong>Saldo total:</strong> ${{format_price(tr.due+tr.debit_balance, 2)}}<br>
                <strong>Ú. abono:</strong> {{ compactDateFormat(tr.last)}}<br>
              </vs-td>
              <vs-td>
                {{tr.finantial_product_str}}<br>
                <strong>Persona:</strong> {{tr.person_type_str}}
              </vs-td>
              <vs-td>
                {{tr.nombre}}<br>
                <a :href="$sanitizeUrl('mailto:' + tr.email)" class="bold">{{tr.email}}</a><br>
                <template v-if="isMoral(tr.user_person_type)"> 
                  <strong>Rep. Legal:</strong> {{ tr.legal_representative }}<br>
                </template>
                <strong>Tel:</strong> {{tr.phone}}<br>
                <span class="bold">{{ tr.location }}</span>
              </vs-td>
              <vs-td>
                <vs-select
                  placeholder="Seleccione"
                  class="w-full"
                  @input="changeCollectionAgent(tr)"
                  v-model="tr.collection_agent_id"
                  >
                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in collectionAgents" />
                </vs-select>
              </vs-td>
              <vs-td>
                <vx-tooltip text="Ver contactos">
                  <vs-button size="large" color="dark" radius icon="visibility" @click="showComponentPopUp(tr, 'contacts')"></vs-button>
                </vx-tooltip>
              </vs-td>
              <vs-td>
                <template v-if="tr.last_collection_effort">
                  <strong>Fecha:</strong> {{ compactDateFormat(tr.last_collection_effort.created_at)}}<br>
                  <strong>Resultado:</strong> {{tr.last_collection_effort.effort_result}}
                </template>
                <template v-if="!isMoral(tr.user_person_type) && tr.last_promise_payment">
                  <br><strong>Promesa de pago:</strong> {{compactDateFormat(tr.last_promise_payment.promise_date)}}<br>
                  <strong>Monto:</strong> ${{format_price(tr.last_promise_payment.amount_promised)}}<br>
                  <strong>Estatus:</strong> {{tr.last_promise_payment.status}}              
                </template>
              </vs-td>
              <vs-td>
                <div class="flex justify-center">
                  <vx-tooltip text="Ver gestiones">
                    <vs-button size="large" color="dark"  icon="visibility" radius class="mr-2" @click="showComponentPopUp(tr, 'efforts')"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="Agregar gestión">
                    <vs-button size="large" color="success" icon="add" radius @click="showComponentPopUp(tr, 'efforts-form')"></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
              <vs-td>
                <vx-tooltip text="Ver bitácora">
                  <vs-button size="large" color="warning" radius icon="visibility" @click="showComponentPopUp(tr, 'notes')"></vs-button>
                </vx-tooltip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>

    <vs-popup v-if="popupComponentActive" :title="componentTitle" class="extended-popup header-primary" :active.sync="popupComponentActive">
      <collection-applicant-contacts v-if="showApplicantContacts" :project-id="currentProject.project_id" :client-id="currentProject.client_id"></collection-applicant-contacts>
      <collection-efforts v-if="showCollectionEfforts" v-on:updated="collectionEffortsUpdated" :only-form="false" :project-id="currentProject.project_id"></collection-efforts>
      <collection-efforts v-if="showCollectionEffortsForm" v-on:updated="collectionEffortsUpdated" :only-form="true" :project-id="currentProject.project_id"></collection-efforts>
      <internal-notes v-if="showInternalNotes" :project-id="currentProject.project_id" :client-id="currentProject.client_id" ></internal-notes>
    </vs-popup>
  </div>

</template>

<script lang="js">
  import dateHelper from "@mixins/dateHelper";
  import formatHelper from "@mixins/formatHelper";
  import CreditStatusEnum from "@/bl/enums/CreditStatusEnum";
  import CollectionApplicantContacts from "@components/projectsv2/CollectionApplicantContacts";
  import CollectionEfforts from "@views/admin/cobranza/components/CollectionEfforts";
  import InternalNotes from "@views/admin/cobranza/components/InternalNotes";

  const columnDefinitions = [
    { title: "PID", key: "id", sortable: false },
    { title: "CRÉDITO", key: "credit", sortable: false },
    { title: "PRODUCTO", key: "product", sortable: false },
    { title: "SOLICITANTE", key: "client", sortable: false },
    { title: "AGENTE COBRANZA", key: "collection_agent", sortable: false },
    { title: "CONTACTOS", key: "contacts", sortable: false },
    { title: "GESTIÓN MÁS RECIENTE", key: "latest_effort", sortable: false },
    { title: "GESTIONES", key: "collection_efforts", sortable: false },
    { title: "BITACORA INTERNA", key: "logs", sortable: false },
  ];

  export default  {
    name: 'DashboardCollectionV2',
    props: [],
    mixins: [dateHelper,formatHelper],
    components:{
      CollectionApplicantContacts,
      CollectionEfforts,
      InternalNotes
    },
    async mounted() {
      await this.getCollections();
      window.document.title = "Cobranza Dashboard";
    },
    data() {
      return {
        columns: columnDefinitions,
        projects: [],
        count: 0,
        total: 0,
        loading: false,
        showing: '',
        status:[
          // CreditStatusEnum.AL_CORRIENTE,
          CreditStatusEnum.EN_PERIODO_GRACIA,
          CreditStatusEnum.RETRASADO_11_30,
          CreditStatusEnum.RETRASADO_31_60,
          CreditStatusEnum.RETRASADO_61_90,
          CreditStatusEnum.VENCIDO
        ],
        // payment_method: [1, 2, 3, 4],
        // payment_method_options:[
        //   {text:'Manual',value:1},
        //   {text:'Automático',value:2},
        //   {text:'Domiciliación',value:3},
        //   {text:'Cuenta concentradora',value:4}
        // ],
        // cut_day: [2, 16],
        // cut_day_options:[
        //   {text:'2',value:2},
        //   {text:'16',value:16}
        // ],
        all_status:[
          {
            value: CreditStatusEnum.AL_CORRIENTE,
            text: 'Al corriente'
          },
          {
            value: CreditStatusEnum.EN_PERIODO_GRACIA,
            text: 'Periodo de gracia'
          },
          {
            value: CreditStatusEnum.RETRASADO_11_30,
            text: 'Retrasado (11 a 30)'
          },
          {
            value: CreditStatusEnum.RETRASADO_31_60,
            text: 'Retrasado (31 a 60)'
          },
          {
            value: CreditStatusEnum.RETRASADO_61_90,
            text: 'Retrasado (61 a 90)'
          },
          {
            value: CreditStatusEnum.VENCIDO,
            text: 'Vencido 91 o más'
          }
        ],
        popupComponentActive: false,
        showApplicantContacts:false,
        showCollectionEfforts:false,
        showCollectionEffortsForm:false,
        showInternalNotes:false,
        currentProject: null,
        componentTitle: "",
        collectionAgents:[],
      }
    },
    methods: {
      async getCollections(){
          try {
              let collectionsObjects = ['collectionAgents'];
              let params = "with[]=" + collectionsObjects.join("&with[]=");
              let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
              let colls = res.data;
              colls.collectionAgents.forEach((opt) => {
                  this.collectionAgents.push({
                      value: opt.id,
                      text: opt.short_name,
                  }); //conversion a sintaxis de vx-select
              });
          } catch (e) {
              this.warn(e);
              this.failed = true;
          }
      },
      isMoral(userPersonType) {
        return userPersonType == 0;
      },
      delayDaysPill(delayedDays){
        let color = "pill-light";
        if (delayedDays >= 90) {
            color = "pill-danger";
        } else {
            if (delayedDays >= 61) {
                color = "pill-orange";
            } else {
                if (delayedDays >= 31) {
                    color = "pill-warning";
                } else {
                    if (delayedDays >= 11) {
                        color = "pill-blue";
                    }
                }
            }                   
        }
        return color;
      },
      showComponentPopUp(project, option){
        this.showApplicantContacts = false;
        this.showCollectionEfforts = false;
        this.showInternalNotes = false;      
        this.showCollectionEffortsForm = false;
        this.currentProject=project;
        switch (option) {
          case 'contacts':
            this.componentTitle="Contactos";
            this.showApplicantContacts = true;
            break;
          case 'efforts':
            this.componentTitle="Gestiones";
            this.showCollectionEfforts = true;
            break;
          case 'efforts-form':
            this.componentTitle="Nueva Gestión";
            this.showCollectionEffortsForm = true;
            break;
          case 'notes':
            this.componentTitle="Bitácora de Cobranza";
            this.showInternalNotes = true;
            break;
          default:
            break;
        }
        this.popupComponentActive = true;
      },
      async collectionEffortsUpdated(){
        this.popupComponentActive = false;
        await this.getProjects();
      },
      async getProjects(){
        this.showLoading(true);
        this.projects = [];
        await axios.post('/api/cobranza/proyectos', {
          status: this.status,
          // cut_day: this.cut_day,
          // payment_method: this.payment_method
        }).then(response => {
          this.projects = response.data;
          this.showLoading(false);
        }).catch(error => {
          this.showLoading(false);
        });
      },
      async changeCollectionAgent(project){
          this.showLoading(true);
          var data = {
              client_id: project.client_id,
              collection_agent_id: project.collection_agent_id
          }
          await axios.post('/api/cobranza/change-collection-agent', data).then(response => {
              this.dataResponse = response.data;
              this.showLoading(false);
              this.successNotif("Aviso", response.data, 4000);
          }).catch(error => {
              this.showLoading(false);
              this.errorNotif("Aviso", error.response.data, 4000);
          });
      },
    }
}
</script>